module.exports = __webpack_public_path__ + "media/images/service/n_13-4d30ad75dc3edff23638e008f73023e6.jpg";